// let ApiServer ='http://localhost:57679';// 'http://localhost:57679'; //'http://47.88.94.214:82';
// ////'http://platform_server.qingguan.wang'; //
 //let WebServer ='hoyuwms.qingguan.wang'; //speedymarket.com,soft.enproec.com'lc.qingguan.wang';yuuweb.qingguan.wang';
//'exportnew.qingguan.wang'////window.location.host;//;soft.bibifrost.com falconexpres.com
let ApiServer ='https://platformserverxg.qingguan.wang'; //'https://platformserverxg.qingguan.wang';'http://platform_server.qingguan.wang'; 
////https://platformstatic.qingguan.wang https://test.kdfei.cn
let WebServer = window.location.host;
let ApiServer_api ='https://platformapi.qingguan.wang';
let modeSever = 'https://daoru.qingguan.wang/';
let ApiUrl = ApiServer;
let headers = {}
let API = {
	get: {
		GetFeelistTemp:ApiServer + '/cw/GetFeelistTemp', //获取常用财务账单模板
		GetExportSet:ApiServer + '/System/GetExportSet', //读取导出筛选条件
		GetCustomerItem:ApiServer + '/Crm/GetCustomerItem', //读取客户资料选项
		GetDeskList:ApiServer + '/Base/GetDeskList', //读取设备参数方案
		GetParamtodevice:ApiServer + '/Base/GetParamtodevice', //读取设备参数方案
		GetPayState:ApiServer + '/Shop/GetPayState', //读取支付状态
		CheckOrder:ApiServer + '/Storage/CheckOrder', //读取要核重的订单
		GetSupplierCargoPrice:ApiServer + '/Base/GetSupplierCargoPrice', //按货品获取供应商报价
		GetqgList: ApiServer + '/Base/GetqgList', //获取航班备注
		getbaojialist: ApiServer + '/HD/getbaojialist', //获取符合条件的报价id
		GetFlightMain: ApiServer + '/HD/GetFlightMain', //获取航班备注
		GetFlightList: ApiServer + '/HD/GetFlightList', //获取货代航班时刻表
		GetSchemeList: ApiServer + '/HD/GetSchemeList', //获取货代报价明细
		GetSchemeMain: ApiServer + '/HD/GetSchemeMain', //获取货代报价主表信息,
		Getqgresult: ApiServer_api + '/api/qgmessage/v1/receipt', //获取最新清关回执结果
		GetLoginParam: ApiServer + '/System/GetLoginParam', //获取登录页参数
		CreateErrorFile: ApiServer + '/Order/CreateErrorFile', //获取错误文档
		GetBwList: ApiServer + '/Base/GetBwList', //获取报文类型信息
		GetQgCompanyList: ApiServer + '/Base/GetQgCompanyList', //获取企业主体信息
		GetArea: ApiServer + '/Base/GetArea', //获取申报地
		GetNoticeMsg: ApiServer + '/Msg/GetNoticeMsg', //获取通知信息
		GetBaojiaNo: ApiServer + '/HD/GetBjNo', //获取报价编号
		GetOrderInfoByLid: ApiServer + '/System/GetOrderInfoByLid', //根据业务表关键值获取详情
		GetOrderWeight: ApiServer + '/Storage/GetOrderWeight', //获取
		CreateGrid: ApiServer + '/System/CreateGrid', //获取列表数据
		AnalysisSearch: ApiServer + '/System/AnalysisSearch', //解析筛选条件
		GetLanguageByMode: ApiServer + '/System/GetLanguageByMode', //获取多语言包
		GetFilterSet: ApiServer + '/System/GetFilterSet', //获取筛选条件
		GetTabs_Only: ApiServer + '/System/GetTabs_Only', //获取权限内的选项卡
		GetButtons: ApiServer + '/System/GetButtons', //获取权限内的模块对应的按钮
		CheckOrderHandleState: ApiServer + '/Order/CheckOrderHandleState', //检测多线程取单号时操作结果
		GetWlcode: ApiServer + '/system/GetWlcode', //读取通用模板
		GetOrderMd: ApiServer + '/File/GetOrderMd', //读取面单
		OpenInvoice: ApiServer + '/cw/OpenInvoice', //打开发票信息
		GetCompany: ApiServer + '/Crm/GetCompany', //调取公司信息
		GetUserPrintset: ApiServer + '/User/GetUserPrintset', //读取权限内的打印模板设置信息
		GetPrintModeList: ApiServer + '/Order/GetPrintModeList', //获取权限内对应渠道的打印模板
		CheckOrderPmodeIsMul: ApiServer + '/Order/CheckOrderPmodeIsMul', //检测批量处理的订单是否所属多个渠道
		GetCargoshelves: ApiServer + '/Storage/GetCargoshelves', //获取商品所在货架
		GetPagecolGroup: ApiServer + '/System/GetPagecolGroup', //获取页面配置分组
		GetStockCargoInOutList_SumCount: ApiServer + '/Storage/GetStockCargoInOutList_SumCount', //获取商品报表汇总数
		GetStocktaking: ApiServer + '/Storage/GetStocktaking', //获取待盘点记录信息
		GetStocktakingCargo: ApiServer + '/Storage/GetStocktakingCargo', //获取待盘点的商品信息
		GetStockCargoWarning: ApiServer + '/Storage/GetStockCargoWarning', //读取商品预警信息
		GetStockCargoReport: ApiServer + '/Storage/GetStockCargoReport', //商品库存明细报表
		GetOrderInfoByCountry: ApiServer + '/Order/GetOrderInfoByCountry', //获取发送邮件提醒的订单信息
		GetCrmidByBandUaccount: ApiServer + '/Crm/GetCrmidByBandUaccount', //获取平台信息新增项配置
		CheckStockNum: ApiServer + '/Storage/CheckStockNum', //获取平台信息新增项配置
		GetDsFormat: ApiServer + '/Base/GetDsFormat', //获取平台信息新增项配置
		GetStock: ApiServer + '/Storage/GetStock', //获取仓库单据信息
		GetOrderTabCount: ApiServer + '/Order/GetOrderTabCount', //获取订单列表汇总
		GetUserDsList: ApiServer + '/system/GetUserDs', //获取用户电商信息(按类型获取)
		GetEmailRecevier: ApiServer + '/Msg/GetEmailRecevier', //获取邮件接收人
		GetDsInfo: ApiServer + '/Base/GetDsInfo', //获取平台信息(按唯一id获取)
		sysinfo: ApiServer + '/System/GetSysInfo',
		getLeftMenu: ApiServer + '/User/getLeftMenu',
		createuser: ApiServer + '/login/createuser',
		updateUserPwd: ApiServer + '/login/UpdateUserPwd',
		dic: ApiServer + '/Base/getdic',
		gettheme: ApiServer + '/System/GetTheme',
		GetRoleList: ApiServer + '/User/GetRoleList',
		Getshop: ApiServer + '/User/GetGroup_Shop', //门店管理列表
		GetGroup: ApiServer + '/User/GetGroup', //获取所有门店
		GetRoleOption: ApiServer + '/User/GetRoleOption',
		GetPayruleOption: ApiServer + '/System/GetPayruleOption',
		GetSystemParam: ApiServer + '/System/GetSystemParam',
		GetRemindSet: ApiServer + '/User/GetRemindSet',
		GetUserList: ApiServer + '/User/GetUserList',
		GetColumns: ApiServer + '/Table/GetColumnsByMode',
		GetUserPermession: ApiServer + '/User/GetUserPermession',
		CreatePageLayout: ApiServer + '/System/CreatePageLayout',
		CreatePageLayoutByPmode: ApiServer + '/System/CreatePageLayoutByPmode',
		GetClarance: ApiServer + '/User/GetClarance',
		GetShopList: ApiServer + '/User/GetShoplist',
		GetTabs: ApiServer + '/System/GetTabs',
		GetOrderInfo: ApiServer + '/Order/GetOrderInfo_Json',
		GetPackageList: ApiServer + '/Order/GetPackageList',
		GetPackageCount: ApiServer + '/Order/GetPackageCount',
		GetGridData: ApiServer + '/Table/GetGridData',
		GetFilter: ApiServer + '/Order/GetFilter',
		GetFile: ApiServer + '/Order/getfile', //下载excel、pdf文件
		MatchOrderCargo: ApiServer + '/Order/matchordercargo', //匹配商品库
		ExportNomatchCargo: ApiServer + '/Order/exportnomatchcargo', //下载未匹配成功的商品信息
		Calculatetaxfee: ApiServer + '/Order/calculate_taxfee', //计算税金
		ExportErrorOrder: ApiServer + '/Order/ExportErrorOrder', //下载导入错误的订单
		getyzmimg: ApiServer + '/Home/getyzmimg',
		CheckPmodetoPrint: ApiServer + '/Order/CheckPmodetoPrint', //验证订单的渠道
		GetPrintBzMode: ApiServer + '/Order/GetPrintBzMode', //根据渠道获取打印模板
		GetTempBatch: ApiServer + '/Order/GetTempBatch_json', //获取临时表批次号中的单号
		GetHszList: ApiServer + '/Order/GetHszList', //回收站列表
		//GetStorageClearance:ApiServer+'/Storage/GetStorageClearance',//获取进出口已启用的渠道
		GetInOutParam: ApiServer + '/Storage/GetInOutParam', //获取出入库参数
		CollectFee: ApiServer + '/Storage/CollectFee', //计算费用
		//CheckandGetorder:ApiServer+'/Storage/CheckandGetorderInfo' ,//出入库打单检测并获取订单信息
		GetStorageList: ApiServer + '/Storage/GetStorageList',
		GetStorageOutParam: ApiServer + '/Storage/GetStorageOutParam',
		GetStoragePmode: ApiServer + '/Storage/GetStoragePmode',
		GetRate: ApiServer + '/Order/GetOrderRate', //获取报价
		GetCountry: ApiServer + '/Base/GetCountry', //获取国家
		GetAddresslist: ApiServer + '/addr/GetAddrlistBySearch', //获取地址库
		CreatePageLayoutType: ApiServer + '/System/CreatePageLayoutType',
		GetDefaultCtaddr: ApiServer + '/addr/GetDefaultCtaddr', //获取默认寄件地址
		SplitAddr: ApiServer + '/addr/SplitAddr', //智能解析地址
		GetInputTips: ApiServer + '/Base/GetInputTips', //获取输入自动提示信息
		GetBaseAddrByPostCode: ApiServer + '/addr/GetBaseAddrByPostCode', //根据邮编获取地址基本信息
		checkprinter: ApiServer + '/order/checkprinter', //判断本机是否包含指定打印机
		GetBaseAddr: ApiServer + '/addr/GetBaseAddr', //获取基础地址信息
		GetLogisticsCount: ApiServer + '/Order/GetLogisticsCount', //物流管理订单汇总
		GetOrderList: ApiServer + '/Order/GetOrderList_Export', //获取订单列表
		getwl: ApiServer + '/Order/getwl_export', //获取物流动态
		GetGridTable: ApiServer + '/Table/GetGridTable',
		Getscheme: ApiServer + '/cw/Getscheme', //获取财务方案明细
		getvipbyvipaccount: ApiServer + '/Home/getvipbyvipaccount', //获取会员卡信息
		GetChargeRate: ApiServer + '/Base/GetChargeRate', //获取币种汇率
		getpayorder: ApiServer + '/cw/getpayorder', //获取支付状态
		GetExportTemplate: ApiServer + '/Order/GetExportTemplate', //获取导出模板
		OrderExport_Batch: ApiServer + '/Order/OrderExport_Batch', //生成导出模板
		GetSchemeType: ApiServer + '/cw/GetSchemeType', //获取权限内的财务方案类型
		Getwl_Batch: ApiServer + '/Order/Getwl_Batch', //批量查询物流
		//GetOrderRate_Batch: ApiServer + '/Order/GetOrderRate_Batch', //批量下单获取报价
		VipBill: ApiServer + '/cw/VipBill', //获取会员卡明细列表 
		GetVipBillCount: ApiServer + '/cw/GetVipBillCount', //获取会员卡明细汇总
		GetSort: ApiServer + '/Base/getcargosort', //获取分类
		PayOrderList: ApiServer + '/Order/PayOrderList', //获取收费状态列表
		PayOrderCount: ApiServer + '/Order/PayOrderCount', //获取收费状态汇总
		CulatefeeOrder: ApiServer + '/cw/CulatefeeOrder', //计算费用生成列表返回
		LoadStoragePrintPage: ApiServer + '/Storage/LoadStoragePrintPage', //获取出入库打单参数
		PredictFee: ApiServer + '/cw/PredictFee', //预估费用
		GetMyWorkList: ApiServer + '/Works/GetMyWorkList', //获取客服管理列表
		GetMyWorkCount: ApiServer + '/Works/GetMyWorkCount', //客服管理汇总
		GetWorkContext: ApiServer + '/Works/GetWorkContext', //获取服务单详情
		CheckOrderPkval: ApiServer + '/Order/CheckOrderPkval', //根据单号获取订单信息
		DownWorkFile: ApiServer + '/Works/DownWorkFile', //下载服务单对话中的附件
		Getkflist: ApiServer + '/Works/Getkflist', //获取订单拦截日志
		GetHandleLog: ApiServer + '/Order/GetHandleLog', //获取订单操作日志
		GetBaseType: ApiServer + '/Base/GetBaseType', //获取基础资料类型
		VipChargePaylist: ApiServer + '/cw/VipChargePaylist', //获取用户充值扣费流水
		GetMode: ApiServer + '/System/GetMode', //获取功能模块
		FeeBooklist: ApiServer + '/cw/FeeBooklist', //操作记账列表
		GetCustomer: ApiServer + '/Crm/GetCustomerList', //获取客户信息列表
		GetCustomerTodeal: ApiServer + '/Crm/GetCustomerTodeal', //获取客户待处理事项列表
		GetCustomerTodealCount: ApiServer + '/Crm/GetCustomerToDealCount', //获取客户待处理事项选项卡汇总数
		Getwaybill_GN: ApiServer + '/Order/Getwaybill_GN', //查询国内快递物流
		GetFeeBookInfo: ApiServer + '/cw/GetFeeBookInfo', //获取账单详情信息
		GetCustomerInfo: ApiServer + '/Crm/GetCustomerInfo', //获取客户详细信息
		GetAirway: ApiServer + '/Order/GetAirway', //获取航空信息
		GetCustomerFollow: ApiServer + '/Crm/GetCustomerFollow', //获取客户跟进记录
		GetSetUserlist: ApiServer + '/User/GetSetUserlist', //设置门店用户
		CollectPaylist: ApiServer + '/cw/CollectPaylist', //获取收付款列表
		GetCollectPayInfo: ApiServer + '/cw/GetCollectPayInfo', //获取收付款详情
		CollectPay_Report: ApiServer + '/cw/CollectPay_Report', //收付款报表
		GetBaseCargoList: ApiServer + '/Base/GetCargoList_Base', //商品库管理列表
		GetBaseCargoInfo: ApiServer + '/Base/GetCargoInfo', //商品资料详情
		GetStockInOutList: ApiServer + '/Storage/GetStockInOutList', //仓库管理-入库/出库 列表
		GetStockList: ApiServer + '/Storage/GetStockList', //仓库管理-库存列表
		GetDicByRole: ApiServer + '/Base/GetDicByRole', //获取权限内的词典信息
		GetPrintMode: ApiServer + '/System/GetPrintMode', //获取打印模板列表
		GetPrintTemp: ApiServer + '/System/GetPrintTemplate', //获取打印模板内容
		GetTaxid: ApiServer + '/System/GetTaxid', //获取税号
		GetHaitaoCount: ApiServer + '/Order/GetHaitaoCount', //获取海淘管理列表
		GetLinkInfo: ApiServer + '/System/GetLinkInfo', //获取功能基本信息
		GetShopByUser: ApiServer + '/User/GetShopByUser', //获取门店基本信息
		GetOrderlistByBatch: ApiServer + '/Storage/GetOrderlistByBatch', //根据批次号获取已扫描订单号
		RemindSet_Wx: ApiServer + '/Base/RemindSet_Wx', //获取微信提醒设置
		GetRemindTempSet: ApiServer + '/Base/GetRemindTempSet', //根据模板唯一id获取微信提醒模板设置
		GetWxReceiver: ApiServer + '/Base/GetWxReceiver', //根据模板唯一id获取微信提醒模板固定接收人
		CreateTempEwm: ApiServer + '/System/CreateTempEwm', //生成临时二维码
		GetStorageHarvest: ApiServer + '/Storage/GetStorageHarvest', //获取揽收记录
		LoadHarvestPage: ApiServer + '/Storage/LoadHarvestPage', //加载揽收扫描界面初始参数
		GetHarvestlistByBatch: ApiServer + '/Storage/GetHarvestlistByBatch', //根据批次号获取已扫描的揽收记录
		GetStorageShelves: ApiServer + '/Storage/GetStorageShelves', //获取上架管理列表
		LoadShelvesPage: ApiServer + '/Storage/LoadShelvesPage', //加载上架操作界面
		GetShelveslistByBatch: ApiServer + '/Storage/GetShelveslistByBatch', //按批次号和货架号获取已扫描订单
		CheckOrderService: ApiServer + '/Order/CheckOrderService', //检测订单是否可以新增、修改增值服务
		LoadWtjPage: ApiServer + '/Storage/LoadWtjPage', //加载问题件界面
		GetWtjlistByBatch: ApiServer + '/Storage/GetWtjlistByBatch', //根据批次号获取问题件
		GetMsgRecevier: ApiServer + '/Msg/GetMsgRecevier', //获取消息接收人
		ComposeMsgTemp: ApiServer + '/Msg/ComposeMsgTemp', //生成要发送的消息内容
		GetEnabledParam: ApiServer + '/System/GetEnabledParam', //获取 开启 \关闭参数值
		GetPhoto: ApiServer + '/Storage/GetPhoto', //获取拍照记录
		DownPhoto: ApiServer + '/Storage/DownPhoto', //下载照片
		GetTransFormat: ApiServer + '/System/GetTransFormat', //根据渠道查找导入配置信息
		GetPagecolSet: ApiServer + '/System/GetPagecolSet', //获取动态生成的页面配置
		GetOrderInfo_More: ApiServer + '/Order/GetOrderInfo_More', //获取订单信息，兼容一票多件
		ShowFile: ApiServer + '/Base/ShowFile', //获取文件base64
		GetApiSecret: ApiServer + '/Home/getapisecret', //获取接口秘钥(用于上传身份证)
		GetDomainByIp: ApiServer + '/System/GetDomainByIp', //检测域名
		GetCargoSortList: ApiServer + '/Cargo/GetCargoSortList', //获取商品分类列表信息
		GetCargoBrand_SC: ApiServer + '/Cargo/GetCargoBrand_SC', //获取品牌信息（包括列表）
		GetSpce_SC: ApiServer + '/Cargo/GetSpce_SC', //获取规格信息
		GetCargoInfo_SC: ApiServer + '/Cargo/GetCargoInfo_SC', //获取商品信息
		GetCargoPic: ApiServer + '/Cargo/GetCargoPic', //获取商品图片
		GetCargoDescribe: ApiServer + '/Cargo/GetCargoDescribe', //获取商品描述信息
		GetIndexcargo: ApiServer + '/Cargo/GetIndexcargo', //获取商城首页设置
		GetPrintOrderList: ApiServer + '/Order/GetPrintOrderList', //获取待打印的订单信息
		DownMdFile: ApiServer + '/System/DownMdFile',
		GetPrintTemplate: ApiServer + '/Order/GetPrintTemplate', //获取权限内的打印模板
		CheckScanOrder: ApiServer + '/Order/CheckScanOrder', //扫描打印
		Gettaxscheme: ApiServer + '/Cargo/Gettaxscheme', //获取商品增值税方案
		GetCargoSort_Last: ApiServer + '/Cargo/GetCargoSort_Last', //获取商品最末级分类
		GetCnoByTaxscheme: ApiServer + '/Cargo/GetCnoByTaxscheme', //获取税率方案对应的商品
		GetWlStep: ApiServer + '/Base/GetWlStep', //获取物流步骤模板
		GetUserds: ApiServer + '/User/GetUserds' //获取用户的店铺信息
	},
	post: {
		DownCargoPic:ApiServer + '/Base/DownCargoPic',//删除常用账单模板
		delfeelisttemp:ApiServer + '/cw/DelFeelistTemp',//删除常用账单模板
		SaveFeelistTemp:ApiServer + '/cw/SaveFeelistTemp',//将常用账单存为模板
		InsertTempBysearch:ApiServer + '/System/InsertTempBysearch', //根据筛选条件保存数据到临时表
		SaveParamtodevice:ApiServer + '/Base/SaveParamtodevice', //保存设备参数方案
		setcargoisshelves:ApiServer + '/Cargo/setcargoisshelves', //释放占用库存
		UpdateTempnum:ApiServer + '/Storage/UpdateTempnum', //释放占用库存
		UploadCargoPriceLabel:ApiServer + '/Cargo/UploadCargoPriceLabel', //上传商品价签数据
		AuditdeviceAccount:ApiServer + '/User/AuditdeviceAccount', //审核账号，硬件设备
		UpdateWeightSingle:ApiServer + '/Order/UpdateWeight', //简单的更新重量
		DelTabledata: ApiServer + '/System/DelTabledata', //通用删除方法，处理无复杂业务逻辑的表
		Delwf: ApiServer + '/cw/Delwf', //删除应付账单记录
		Delws: ApiServer + '/cw/Delws', //删除应收账单记录
		Deldd: ApiServer + '/HD/Deldd', //删除货代订单记录
		Delbj: ApiServer + '/HD/Delbj', //删除报价记录
		Delxj: ApiServer + '/HD/Delxj', //删除询价记录
		delqgaccount: ApiServer + '/Base/delqgaccount', //删除申报企业账号信息，
		saveqgaccount: ApiServer + '/Base/saveqgaccount', //保存推送单一窗口账号信息，
		delbaojialist: ApiServer + '/HD/delbaojialist', //删除报价方案，
		SaveFlightList: ApiServer + '/HD/SaveFlightList', //保存航班时刻表明细，
		SaveFlightMain: ApiServer + '/HD/SaveFlightMain', //保存航班时刻表主信息
		SaveSchemeMain: ApiServer + '/HD/SaveSchemeMain', //保存货代报价表主信息
		SaveSchemeList: ApiServer + '/HD/SaveSchemeList', //保存货代报价表明细
		submitqg: ApiServer_api + '/api/qgmessage/v1', //推送清关报文到单一窗口
		CreateCopyContent: ApiServer + '/System/CreateCopyContent', //保存公告通知信息
		SyncCargoimg: ApiServer + '/Cargo/SyncCargoimg', //同步商品图片
		SaveNoticeMsg: ApiServer + '/msg/SetNoticeMsg', //保存公告通知信息
		SaveCwBill: ApiServer + '/cw/SaveCwBill', //生成财务账单记录
		AddStorageIn: ApiServer + '/Storage/AddStorageIn', //添加核重记录到入库记录表
		CheckOrderWeight: ApiServer + '/Storage/CheckOrderWeight', //核对订单重量和费用
		CheckOrderPayState: ApiServer + '/Shop/CheckOrderPayState', //检测订单支付状态
		CreatePayOrder: ApiServer + '/Shop/CreatePayOrder',
		OrderPay: ApiServer + '/Shop/OrderPay', //订单支付
		WxChatGetsignature: ApiServer + '/Msg/WxChatGetsignature',
		WxChatSendMsg: ApiServer + '/Msg/WxChatSendMsg',
		ThreadPrint: ApiServer + '/Order/ThreadPrint', //多线程取单号
		SaveDataTemptoExcelTemp: ApiServer + '/System/SaveDataTemptoExcelTemp', //保存数据临时信息到操作临时表
		SaveInput: ApiServer + '/System/SaveInput', //保存临时信息
		SubWl: ApiServer + '/Logistics/SubWl', //订阅物流
		SaveCrmExtend: ApiServer + '/crm/SaveCrmExtend', //保存发票
		SaveInvoice: ApiServer + '/cw/SaveInvoice', //保存发票
		DownSysOrder: ApiServer + '/Order/DownSysOrder', //下载平台订单
		CreateStockserialnumber: ApiServer + '/Storage/CreateStockserialnumber', //生成发票序列号
		SavePrintset: ApiServer + '/User/SavePrintset', //保存打印设置
		RollBackStockBill: ApiServer + '/Storage/RollBackStockBill', //回滚出入库单据记录
		Deltacking: ApiServer + '/Storage/Deltacking', //删除盘点记录
		RefundOrder: ApiServer + '/Order/RefundOrder', //彻底删除回收站的订单，删除前需判断是否已支付
		Deltrashorder: ApiServer + '/Order/Deltrashorder', //彻底删除回收站的订单，删除前需判断是否已支付
		ChangeOrderState: ApiServer + '/Order/ChangeOrderState', //订单转换表
		SetCargoShelves: ApiServer + '/Storage/SetCargoShelves', //分配货架
		DelStockPlan: ApiServer + '/Storage/DelStockPlan', //删除出口计划单
		UpdateStock: ApiServer + '/Storage/UpdateStock', //更新库存
		Resolvepkval: ApiServer + '/Order/Resolvepkval', //生成压缩文件
		DownFile: ApiServer + '/Order/DownFile', //生成压缩文件
		CreateClearXml: ApiServer + '/Order/CreateClearXml', //生成清关报文
		Translationorder: ApiServer + '/Order/Translationorder', //智能翻译
		Verifyid: ApiServer + '/Order/Verifyid', //订单验证号码
		Setemailtemp: ApiServer + '/Msg/Setemailtemp', //设置邮件提醒模板
		SendEmailMsg: ApiServer + '/Msg/SendEmailMsg', //发送邮件提醒
		DelDsInfo: ApiServer + '/Base/DelDsInfo', //删除平台信息
		SaveDsInfo: ApiServer + '/Base/SaveDsInfo', //保存平台信息
		OrderPrint: ApiServer + '/Order/OrderPrint', //打印面单
		// 保存注册用户
		registerAccount: ApiServer + '/Home/registerAccount',
		// 登录
		login: ApiServer + '/Home/CheckLogin',
		// token登录
		checkBytoken: ApiServer + '/Home/LoginbyId',
		SaveGroup: ApiServer + '/User/SaveGroup',
		DelGroup: ApiServer + '/User/DelGroup',
		SaveUserInfo: ApiServer + '/User/SaveUserInfo',
		SaveUserRank: ApiServer + '/User/SaveUserRank', //设置用户等级和管理员
		DelUser: ApiServer + '/User/DelUser',
		GetPermession: ApiServer + '/User/GetPermession',
		SaveRoleInfo: ApiServer + '/User/SaveRole',
		DelRole: ApiServer + '/User/DelRole',
		SaveOrder: ApiServer + '/Order/saveorder_newpt',
		SavePackageInfo: ApiServer + '/Order/SavePackageInfo', //保存包裹订单信息
		SetOrderToTrash: ApiServer + '/Order/SetOrderToTrash',
		SetUserRole: ApiServer + '/User/SetUserRole',
		InsertTemp: ApiServer + '/System/InsertTemp',
		SetSendType: ApiServer + '/Order/SetSendType',
		SaveInport: ApiServer + '/Order/SaveInport', //保存导入信息
		RollBack_Order: ApiServer + '/Order/RollBack_Order', //回滚订单导入信息
		ThreadResolve: ApiServer + '/Order/threadresolve_ct', //解析寄件地址
		ThreadResolve_cg: ApiServer + '/Order/threadresolve_cg', //解析收件地址
		SetIntercept: ApiServer + '/Order/SetIntercept', //设置拦截
		DeleteOrder: ApiServer + '/Order/DeleteOrder', //删除订单
		RollbackStorage: ApiServer + '/Storage/RollbackStorage', //出入库失败回滚
		//SaveOrdertoStorage:ApiServer+'/Storage/SaveOrdertoStorage',//保存出入库记录
		CreateStep: ApiServer + '/Order/CreateStep',
		DelStorageOrder: ApiServer + '/Storage/DelStorageOrder', //删除出入库记录
		SetClearisEnabled: ApiServer + '/Storage/SetClearisEnabled', //设置出入库渠道启用/停用
		SaveStorageOutParam: ApiServer + '/Storage/SaveStorageOutParam',
		DeleteAddr: ApiServer + '/addr/DeleteAddr', //删除地址
		SetDefaultCtAddr: ApiServer + '/addr/SetDefaultCtAddr', //设置默认地址
		SendMessage: ApiServer + '/Msg/SendMessage', //发送消息提醒
		CheckPmodetoPrint: ApiServer + '/Order/CheckPmodetoPrint',
		SavelogisticsOrder: ApiServer + '/Order/SavelogisticsOrder', //保存物流下单
		CheckPasteOrder: ApiServer + '/Order/CheckPasteOrder', //检测输入的单号
		PrintPerView: ApiServer + '/Order/PrintPerView', //批量预览，合并输出
		SetViptocw: ApiServer + '/cw/SetVipCw', //设置会员的财务方案
		Delscheme: ApiServer + '/cw/Delscheme', //删除财务方案
		Savescheme: ApiServer + '/cw/Savescheme', //保存计费方案
		VipCharge: ApiServer + '/cw/VipCharge', //会员卡充值
		SaveVipCharge: ApiServer + '/cw/SaveVipCharge', //保存会员卡充值信息
		SavePwd: ApiServer + '/User/SavePwd', //重置密码
		SaveVipCharge_Move: ApiServer + '/cw/SaveVipCharge_Move', //会员卡金额转移
		SaveOrder_Batch: ApiServer + '/Order/SaveOrder_Batch', //保存批量下单
		BatchCreateMd: ApiServer + '/Order/BatchCreateMd', //批量下单获取快递单号，有错误的信息回滚，并返回错误详情
		SaveOrder_More: ApiServer + '/Order/SaveOrder_More', //保存多件下单信息
		CreateMd_More: ApiServer + '/Order/CreateMd_More',
		SurePayOrder: ApiServer + '/cw/SurePayOrder', //确认收费
		CancelPayOrder: ApiServer + '/cw/CancelPayOrder', //取消收费
		DelPayOrderTemp: ApiServer + '/cw/DelPayOrderTemp', //删除临时计算收费的数据
		StorageInOutHandle: ApiServer + '/Storage/StorageInOutHandle', //出入库检测订单和保存操作
		UpdateOutBatch: ApiServer + '/Storage/UpdateOutBatch', //更新批次号
		SaveUserParam: ApiServer + '/Storage/SaveUserParam', //保存用户参数设置
		UpdateWeight: ApiServer + '/Storage/UpdateWeight', //批量更新称重重量(根据导入的重量更新，导出有差额的)
		OrderIntercept: ApiServer + '/Order/OrderIntercept', //订单拦截
		CancelIntercept: ApiServer + '/Order/CancelIntercept', //订单取消拦截
		MoveUser: ApiServer + '/User/MoveUser', //转移人员分组
		SaveWork: ApiServer + '/Works/Savework', //保存客服管理首次提交的问题
		SaveWorkContext: ApiServer + '/Works/SaveWorkContext', //保存客服处理/回复信息
		DelBaseInfo: ApiServer + '/Base/DelBaseInfo', //删除基础资料
		SaveBaseInfo: ApiServer + '/Base/SaveBaseInfo', //保存基础资料
		SaveFeeBook: ApiServer + '/cw/SaveFeeBook', //保存记账单
		DelFeeBook: ApiServer + '/cw/DelFeeBook', //删除记账单
		UpdatePerCent: ApiServer + '/cw/UpdatePerCent', //设置订单提成比例
		SetOrderEnd: ApiServer + '/cw/SetOrderEnd', //设置订单完结
		SaveCustomer: ApiServer + '/Crm/SaveCustomer', //保存客户信息
		DelCustomer: ApiServer + '/Crm/DelCustomer', //删除客户信息
		SaveCustomerFollow: ApiServer + '/Crm/SaveCustomerFollow', //保存客户跟进记录
		UpdateUserShopname: ApiServer + '/User/UpdateUserShopname', //更新用户所属门店
		SavelogisticsOrder_xnd: ApiServer + '/Order/SavelogisticsOrder_xnd', //保存物流下单(鑫诺达)
		UpdateWeight_xnd: ApiServer + '/Order/UpdateWeight_xnd', //更新重量(鑫诺达)
		DelCollectPay: ApiServer + '/cw/DelCollectPay', //删除收付款记录
		SaveCollectPay: ApiServer + '/cw/SaveCollectPay', //保存收付款记录
		DelBaseCargo: ApiServer + '/Base/DelBaseCargoList', //删除商品库资料
		SaveBaseCargoInfo: ApiServer + '/Base/SaveBaseCargoInfo', //保存商品库资料
		DelStockIn: ApiServer + '/Storage/DelStockIn', //删除入库单
		DelStockOut: ApiServer + '/Storage/DelStockOut', //删除出库单
		DelStockInPlan: ApiServer + '/Storage/DelStockInPlan', //删除入库计划单
		SaveStockOut: ApiServer + '/Storage/SaveStockOut', //保存出库单
		//SaveOrderStock: ApiServer + '/Order/SaveOrder_Stock', //保存出库计划单
		DelStockOut_Plan: ApiServer + '/Storage/DelStockOut_Plan', //删除出库计划单
		SureStockOut: ApiServer + '/Storage/SureStockOut', //计划单确认出库
		MergePdf: ApiServer + '/Order/MergePdf', //合并文件
		SavePrintTemplate: ApiServer + '/System/SavePrintTemplate', //保存打印模板
		UpdateGridCol: ApiServer + '/System/UpdateGridCol', //更新指定表的指定字段
		BatchUpdate: ApiServer + '/Order/BatchUpdate', //批量更新
		Saveyubao: ApiServer + '/Order/Saveyubao', //订单预报
		SaveRemindSet: ApiServer + '/Base/SaveRemindSet', //保存提醒设置
		SaveWxReceiver: ApiServer + '/Base/SaveWxReceiver', //保存微信提醒固定接收人
		HandleHarvestPage: ApiServer + '/Storage/HandleHarvestPage', //揽收扫描单后之后的操作
		DelStorageHarvest: ApiServer + '/Storage/DelStorageHarvest', //删除揽收记录
		DelStorageShelves: ApiServer + '/Storage/DelStorageShelves', //删除上架记录
		SaveStorageShelves: ApiServer + '/Storage/SaveStorageShelves', //保存上架记录
		SaveOrderService: ApiServer + '/Order/SaveOrderService', //保存增值服务
		SaveOrderService_All: ApiServer + '/Order/SaveOrderService_All', //增值服务全部已处理
		HandleWtjPage: ApiServer + '/Storage/HandleWtjPage', //操作问题件
		SendMsg: ApiServer + '/Msg/SendMsg', //发送消息
		SavePhoto: ApiServer + '/Storage/SavePhoto', //保存拍照图片
		DelPhoto: ApiServer + '/Storage/DelPhoto', //删除照片
		SaveInfo: ApiServer + '/System/SaveInfo', //保存信息，与导入功能结合使用的，什么功能可以新增，什么信息就组合成导入信息
		GoOrderPrint: ApiServer + '/Order/GoOrderPrint', //下快递单/打印/预览订单
		SaveaddressCt: ApiServer + '/Base/saveaddress_ct_export', //保存寄件地址
		SaveaddressCg: ApiServer + '/Base/saveaddress_cg_export', //保存收件地址
		GetImportFee: ApiServer + '/Order/GetImportFee', //批量获取报价
		GetOrderFeeList: ApiServer + '/Order/GetOrderFeeList', //单个获取报价
		DelBaseCargoPic: ApiServer + '/Base/DelBaseCargoPic', //删除商品图片
		SaveCNS: ApiServer + '/System/SaveCNS', //保存承诺书内容
		SetCargoPublic: ApiServer + '/Base/SetCargoPublic', //设置商品开放属性
		SaveCargoBrand_SC: ApiServer + '/Cargo/SaveCargoBrand_SC', //保存商城商品品牌
		SaveCargoSort_SC: ApiServer + '/Cargo/SaveCargoSort_SC', //保存商城商品分类
		DelCargoSort_SC: ApiServer + '/Cargo/DelCargoSort_SC', //删除商城分类
		DelCargoBrand_SC: ApiServer + '/Cargo/DelCargoBrand_SC', //删除商城品牌
		SaveSpec_SC: ApiServer + '/Cargo/SaveSpec_SC', //保存商品规格
		DelSpce_SC: ApiServer + '/Cargo/DelSpce_SC', //删除商品规格
		BindSort: ApiServer + '/Cargo/BindSort', //绑定分类
		SaveCargo_SC: ApiServer + '/Cargo/SaveCargo_SC', //保存商城商品信息
		SaveCargoPic: ApiServer + '/Cargo/SaveCargoPic', //保存商品主图\轮播图
		SaveCargoDescribe: ApiServer + '/Cargo/SaveCargoDescribe', //保存商品描述
		SetCargoenabled: ApiServer + '/Cargo/SetCargoenabled', //设置商品资料启用/停用
		SetCargoSortenabled: ApiServer + '/Cargo/SetCargoSortenabled', //设置商品分类启用/停用
		SetCargoBrandenabled: ApiServer + '/Cargo/SetCargoBrandenabled', //设置商品品牌启用/停用
		SaveIndexCargo: ApiServer + '/Cargo/SaveIndexCargo', //保存商城首页设置
		UpdatePrintState: ApiServer + '/Order/UpdatePrintState', //更新打印状态
		ClearExpress: ApiServer + '/Order/ClearExpress', //清空快递信息
		Savetaxscheme: ApiServer + '/Cargo/Savetaxscheme', //保存商品增值税方案
		Deltaxscheme: ApiServer + '/Cargo/Deltaxscheme', //删除商品增值税方案
		SaveCargotoTaxscheme: ApiServer + '/Cargo/SaveCargotoTaxscheme', //保存商品与税率方案的对应关系
		DelWlStep: ApiServer + '/Base/DelWlStep', //删除物流步骤模板
		SaveWlStep: ApiServer + '/Base/SaveWlStep', //保存物流步骤模板
		CreateOrderStep: ApiServer + '/Order/CreateOrderStep', //订单生成物流
		PushOrderWl: ApiServer + '/Logistics/PushOrderWl', //推送订单物流
		ImportOrderPush: ApiServer + '/Logistics/ImportOrderPush', //导入订单后推送物流
	}
}
let getApi = i => {
	return '请使用对象方式调用api';
}
export default {
	API,
	ApiServer,
	headers,
	getApi,
	WebServer,
	modeSever
}